declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

const PIXEL_ID = '25814268694867293'

let initialized = false

export function initMetaPixel() {
  if (initialized) return

  const f = window
  const b = document

  if (f.fbq) return

  const n: any = (f.fbq = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = b.getElementsByTagName('script')[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', PIXEL_ID)

  initialized = true
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'El Fin del Insomnio por Ansiedad - eBook',
      content_type: 'product',
      value: 6.36,
      currency: 'USD',
    })
  }
}
